import Vue from 'vue/dist/vue';
import { formSending } from '@library/forms/form-sending';
import { formValidation } from '@library/forms/validation';
import { form } from '@scripts/mixins/form';
import { apiServiceStationRequest } from '@scripts/api-methods';
import { VALIDATION_MESSAGES, VALIDATION_RULES } from '@scripts/constants';
import { INPUT_MASKS } from '@library/scripts/constants';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);

const formDataScheme = () => ({
    name: '',
    phone: '',
    address: '',
    site: '',
    itn: '',
    company: '',
});

export default (el, name) =>
    new Vue({
        el,
        name,
        data: () => ({
            formData: formDataScheme(),
            masks: {
                phone: INPUT_MASKS.PHONE_MASK,
            },
        }),
        mixins: [
            form(),
            formSending({ useRecaptcha: true }),
            formValidation(
                {
                    name: {
                        field: 'formData.name',
                        rules: {
                            required: true,
                            ...VALIDATION_RULES.SMALL200_TEXT,
                        },
                    },
                    phone: {
                        field: 'formData.phone',
                        rules: {
                            required: true,
                            ...VALIDATION_RULES.PHONE,
                        },
                    },
                    address: {
                        field: 'formData.address',
                        rules: {
                            required: true,
                            ...VALIDATION_RULES.LARGE_TEXT,
                        },
                    },
                    company: {
                        field: 'formData.company',
                        rules: {
                            required: true,
                            ...VALIDATION_RULES.LARGE_TEXT,
                        },
                    },
                    inn: {
                        field: 'formData.inn',
                        rules: {
                            required: true,
                            ...VALIDATION_RULES.INN,
                        },
                    },

                    site: {
                        field: 'formData.site',
                        rules: {
                            required: false,
                            ...VALIDATION_RULES.SMALL200_TEXT,
                        },
                    }
                },
                VALIDATION_MESSAGES
            ),
        ],
        methods: {
            clearForm() {
                this.formData = formDataScheme();
            },
            sendRequest() {
                const f = this.formData;

                return this.sendForm(() =>
                    apiServiceStationRequest(
                        this.optionalPayload({
                            name: f.name,
                            phone: f.phone,
                            address: f.address,
                            company: f.company,
                            inn: f.inn,
                            site: this.isOptional(f.site, ''),
                            captcha_token: this.token,
                        })
                    )
                );
            },
        },
    });